




















































import { SaveVideoUserEditData } from '@/models/SaveVideoUserEditData'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import Vue from 'vue'

extend('required', {
  ...required,
  message: '{_field_}は必須です',
})

type DataType = {
  data: SaveVideoUserEditData
}

export default Vue.extend({
  name: 'SaveVideoModal',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data(): DataType {
    return {
      data: {
        name: '',
        title: '',
        comment: '',
      },
    }
  },
  methods: {
    submit: function (): void {
      this.$emit('submit', this.data)
      this.$modal.hide('save-video-modal')
      this.data = {
        name: '',
        title: '',
        comment: '',
      }
    },
    cancel: function (): void {
      this.$emit('cancel')
      this.$modal.hide('save-video-modal')
      this.data = {
        name: '',
        title: '',
        comment: '',
      }
    },
  },
})
